import { useQuery } from '@tanstack/react-query';

import { axiosInt, API_CORE_URL } from '../../../utils';

export const FETCH_MODEL_INSTANCE_KEY = 'fetchModelInstance';
export const fetchModelInstanceApi = async (id: string): Promise<any> => {
  const response = await axiosInt.get(`${API_CORE_URL}/model-instances/${id}`);
  return response.data;
};

const useFetchModelInstance = (id: string) => {
  const {
    data: modelInstance,
    isLoading: isLoadingModelInstance,
    error: errorFetchingModelInstance,
  } = useQuery<any>({
    queryKey: [FETCH_MODEL_INSTANCE_KEY, id],
    queryFn: () => fetchModelInstanceApi(id),
  });

  return { modelInstance, isLoadingModelInstance, errorFetchingModelInstance };
};

export default useFetchModelInstance;
